import styled from 'styled-components'
import { Page as BasePage } from '../UserApprovals/styled'
import { FormWrapper, FormInput } from 'components/Form/Core/styled'

export const Page = styled(BasePage)`
  min-width: 0;
  section { min-width: 0; }
`

export const RequestForm = styled.div`
  ${FormWrapper} {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  ${FormInput} { max-width: 100%; min-width: 0; }
  ${FormInput}:last-child { grid-column: 1 / -1; }
  @media (max-width: 767px) {
    ${FormWrapper} { grid-template-columns: minmax(0, 1fr); }
  }
`


export const AccessTable = styled.div`
  min-width: 0;
  @media (max-width: 767px) {
    table { table-layout: fixed; border-spacing: 2px; }
    && th, && td { white-space: normal; padding: 8px 6px; font-size: 13px; }
    th:nth-child(1) { width: 40%; }
    th:nth-child(2) { width: 34%; }
    th:nth-child(3) { width: 26%; }
    button { min-width: 0; max-width: 100%; padding: 6px; font-size: 13px; }
  }
`
